import { render, staticRenderFns } from "./Report_wholesale.vue?vue&type=template&id=497cd89c&scoped=true&"
import script from "./Report_wholesale.vue?vue&type=script&lang=js&"
export * from "./Report_wholesale.vue?vue&type=script&lang=js&"
import style0 from "./Report_wholesale.vue?vue&type=style&index=0&id=497cd89c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497cd89c",
  null
  
)

export default component.exports